import { Outlet, useLocation, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { MessageSquare } from 'lucide-react';
import { Tabs } from '@/components/ui/Tabs';
import { IntegrationsBackLink } from '@/pages/settings/ClinicIntegrations';
import { SettingsSubpageHeader } from './settingsChrome';

export function SmsSettingsLayout() {
  const { t } = useTranslation();
  const location = useLocation();
  const navigate = useNavigate();
  const automation = location.pathname.endsWith('/automation');
  const value = automation ? 'automation' : 'overview';

  return (
    <div className="flex min-w-0 flex-col gap-s4">
      <IntegrationsBackLink />
      <SettingsSubpageHeader
        icon={<MessageSquare className="h-5 w-5" aria-hidden />}
        title={t('settings.integrations.cards.sms_title')}
        subtitle={t('settings.integrations.cards.sms_description')}
      />
      <Tabs
        ariaLabel={t('settings.integrations.sms_tabs_label')}
        overflowLabel={(n) => t('design.more_tabs', { count: n })}
        value={value}
        onChange={(id) => {
          navigate(id === 'automation' ? '/settings/sms/automation' : '/settings/sms');
        }}
        items={[
          { id: 'overview', label: t('settings.integrations.sms_tabs.overview') },
          { id: 'automation', label: t('settings.integrations.sms_tabs.automation') },
        ]}
      />
      <Outlet />
    </div>
  );
}
